  
  import {MenuItemInterface} from "../interface/MenuItemInterface"

  const menuItems : MenuItemInterface[] = [
    {
      label: "home",
      icon: 'pi-home',
      url: "/home",
      permission: "HOME",
      hasDivider: false
    },
    {
      label: "consumo",
      icon: 'pi-chart-bar',
      url: "/consumo",
      permission: "CONSUMO",
      hasDivider: false
    },
    {
      label: "dashboardRepresentante",
      icon: 'pi-chart-pie',
      url: "/dashboard-representante",
      permission: "DASHBOARD_REPRESENTANTE",
      hasDivider: false
    },
    {
      label: "consultaCredito",
      icon: 'pi-search',
      url: "/consultar",
      permission: "CONSULTAR",
      hasDivider: false
    },
    {
      label: "registro",
      icon: 'pi-id-card',
      url: "/registro",
      permission: "REGISTRO_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "consultaLote",
      icon: ' pi-desktop',
      url: "/consultalote",
      permission: "CONSULTA_LOTE_VISUALIZAR",
      hasDivider: true
    },
    {
      label: "opcaoConsultaLote",
      icon: ' pi-database',
      url: "/opcaoconsultalote",
      permission: "OPCAO_CONSULTA_LOTE_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "propostaCredito",
      icon: ' pi-search-plus',
      url: "/proposta",
      permission: "PROPOSTA_CREDITO",
      hasDivider: true
    },
    {
      label: "historicoPropostaCredito",
      icon: ' pi-list-check',
      url: "/historicoproposta",
      permission: "PROPOSTA_CREDITO_HISTORICO",
      hasDivider: false
    },
    {
      label: "formulaCredito",
      icon: ' pi-sliders-h',
      url: "/formula",
      permission: "MOTOR_CREDITO_FORMULA_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "motorCredito",
      icon: ' pi-sliders-v',
      url: "/motorcredito",
      permission: "MOTOR_CREDITO_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "resultadoMotorCredito",
      icon: ' pi-align-left',
      url: "/resultadomotorcredito",
      permission: "RESULTADO_MOTOR_CREDITO_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "historicoConsulta",
      icon: ' pi-history',
      url: "/historico",
      permission: "CONSULTA_VISUALIZAR",
      hasDivider: true
    },
    {
      label: "arquivoRegistro",
      icon: 'pi-folder',
      url: "/arquivoregistro",
      permission: "ARQUIVOREGISTRO_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "relatorioConsulta",
      icon: ' pi-filter',
      url: "/filtrarconsultasintetica",
      permission: "RELATORIO_CONSULTA_SINTETICA",
      hasDivider: false
    },
    {
      label: "relatorioApuracaoBilhete",
      icon: ' pi-filter',
      url: "/filtrarapuracaobilhete",
      permission: "RELATORIO_APURACAO_BILHETE",
      hasDivider: false
    },
    {
      label: "relatorioClienteAtivo",
      icon: ' pi-filter',
      url: "/filtrarclienteativo",
      permission: "RELATORIO_CLIENTE_ATIVO",
      hasDivider: false
    },
    {
      label: "faturamento",
      icon: 'pi-wallet',
      url: "/faturamento",
      permission: "FATURAMENTO_VISUALIZAR",
      hasDivider: true
    },
    {
      label: "fatura",
      icon: 'pi-dollar',
      url: "/fatura",
      permission: "FATURA_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "notaFiscal",
      icon: 'pi-file',
      url: "/nota-fiscal",
      permission: "NOTA_FISCAL_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "servico",
      icon: 'pi-server',
      url: "/servico",
      permission: "SERVICO_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "plano",
      icon: 'pi-briefcase',
      url: "/plano",
      permission: "PLANO_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "usuario",
      icon: 'pi-users',
      url: "/usuario",
      permission: "USUARIO_VISUALIZAR",
      hasDivider: true
    },
    {
      label: "franquia",
      icon: "pi-building",
      url: "/franquia",
      permission: "FRANQUIA_VISUALIZAR",
      hasDivider: false,
    },
    {
      label: "cliente",
      icon: 'pi-tag',
      url: "/cliente",
      permission: "CLIENTE_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "representante",
      icon: "pi-address-book",
      url: "/representante",
      permission: "REPRESENTANTE_VISUALIZAR",
      hasDivider: false,
    },
    {
      label: "notificacao",
      icon: "pi-megaphone",
      url: "/notificacao",
      permission: "NOTIFICACAO_VISUALIZAR",
      hasDivider: false,
    },
    {
      label: "campanha",
      icon: 'pi-gift',
      url: "/campanha",
      permission: "CAMPANHA_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "perfil",
      icon: 'pi-id-card',
      url: "/perfil",
      permission: "PERFIL_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "permissao",
      icon: 'pi-code',
      url: "/permissao",
      permission: "PERMISSAO_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "parametrosAplicacao",
      icon: 'pi-cog',
      url: "/parametros",
      permission: "PARAMETRO_VISUALIZAR",
      hasDivider: false
    }
    
  ];
 
  export default menuItems;
  